export { SuiCollapseModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/modules/collapse/public.js
// module id = 1099
// module chunks = 0